import { baseUseNotifyStore } from '@nuxtDatakodeUtils/store/notify'
import { baseUseConfigStore } from '@nuxtDatakodeUtils/store/config'
import { baseUseUserStore } from '@nuxtDatakodeUtils/store/user'

export const useNotifyStore = baseUseNotifyStore
export const useConfigStore = baseUseConfigStore
export const useUserStore = baseUseUserStore
